class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    FacetFiltersForm.renderConditionStockCount();
    FacetFiltersForm.styleConditionFacets();
  }

  static hasActiveConditionFilter() {
    const searchParams = new URLSearchParams(window.location.search);
    return Array.from(searchParams.keys()).some((key) => {
      const normalizedKey = key.toLowerCase();
      return normalizedKey.includes('condition') || normalizedKey.includes('grade') || normalizedKey.includes('cosmetic');
    });
  }

  static renderConditionStockCount() {
    if (!FacetFiltersForm.hasActiveConditionFilter()) return;

    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const count = productGrid.querySelectorAll('.product-card-wrapper').length;
    const countText = count === 1 ? '1 product' : `${count} products`;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      container.innerHTML = countText;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = countText;
      containerDesktop.classList.remove('loading');
    }
  }

  static styleConditionFacets() {
    document.querySelectorAll('.active-facets__button-inner').forEach((button) => {
      const text = button.textContent.trim().toLowerCase().replace(/[_-]/g, ' ');
      button.classList.remove(
        'active-facets__button-inner--condition-like-new',
        'active-facets__button-inner--condition-good',
        'active-facets__button-inner--condition-fair'
      );

      if (!/(condition|grade|cosmetic)\s*:/.test(text)) return;

      if (text.includes('like new') || text.includes('grade a') || text.includes('excellent') || text.includes('premium')) {
        button.classList.add('active-facets__button-inner--condition-like-new');
      } else if (text.includes('good') || text.includes('grade b')) {
        button.classList.add('active-facets__button-inner--condition-good');
      } else if (text.includes('fair') || text.includes('grade c')) {
        button.classList.add('active-facets__button-inner--condition-fair');
      }
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.renderConditionStockCount();
FacetFiltersForm.styleConditionFacets();

// price code change
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.range-slider input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
      this.querySelectorAll('.number-slider input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    // this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    // this.setMinAndMaxValues();
    this.adjustToValidValues(event.currentTarget);
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('.range-slider input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    // if (minInput.value) maxInput.setAttribute('min', minInput.value);
    // if (minInput.value === '') maxInput.setAttribute('min', 0);
    // if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    let minPrice = inputs[0].value;
    let maxPrice = inputs[1].value;
    if (minPrice > maxPrice) {
      let tempValue = maxPrice;
      maxPrice = minPrice;
      minPrice = tempValue;
      return true
    }
    return false
  }

  adjustToValidValues(input) {
    const isRange = (input.type == "range");
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;

    // Ruler
    const rangeInputs = this.querySelectorAll('.range-slider input');
    const numberInputs = this.querySelectorAll('.number-slider input');
    const minRangeInput = rangeInputs[0];
    const maxRangeInput = rangeInputs[1];
    const minNumberInput = numberInputs[0];
    const maxNumberInput = numberInputs[1];
    let minPrice = isRange ? rangeInputs[0].value : numberInputs[0].value;
    let maxPrice = isRange ? rangeInputs[1].value : numberInputs[1].value;

    if (Number(minPrice) > Number(maxPrice)) {
      let tempValue = maxPrice;
      maxPrice = minPrice;
      minPrice = tempValue;
      minRangeInput.value= minPrice;
      minNumberInput.value= minPrice;
      maxRangeInput.value = maxPrice;
      maxNumberInput.value = maxPrice;
    }else{
      if(input.classList.contains("rulerinput-min")){
        // document.getElementById("rulermin-value").innerHTML = input.value
        isRange ? minNumberInput.value = minPrice : minRangeInput.value= minPrice;
      }
      if(input.classList.contains("rulerinput-max")) {
        // document.getElementById("rulermax-value").innerHTML = input.value
        isRange ? maxNumberInput.value = maxPrice : maxRangeInput.value= maxPrice;
      }
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
